import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setUpdateSubscriptionInfo } from '../../feature/showSlice/updateSubscriptionSlice';
import { subscriptionActive } from "../../api/handleapi";

export const useInitializeSubscription = (firebaseUseruid) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!firebaseUseruid) return;

    const fetchSubscription = async () => {
      try {
        const data = await subscriptionActive(firebaseUseruid);
        
        dispatch(setUpdateSubscriptionInfo(data));
        localStorage.setItem("subscriptionInfo", JSON.stringify(data));
      } catch (err) {
        console.error("Error cargando suscripción:", err);
      }
    };

    fetchSubscription();
  }, [firebaseUseruid, dispatch]);
};
